import enhance from './CommissionContainer';
import ParentForm from './components/ParentForm';

export default enhance(ParentForm);
